import {
  ALPHANUMERICWITHSPACEREGEX,
  EMAILREGEX,
  NUMBERREGEX,
  WEBSITEREGEX,
} from "../../App.config";

export const initialState = {
  createdOnDate: {
    value: "",
  },
  createdBy: {
    value: "",
  },
  lastUpdateDate: {
    value: "",
  },
  companyName: {
    value: [],
    error: "",
    validation: { required: true },
    step: 1,
    positionCount: 1,
    // label: "STD-Employer-Statement.form.label.text.FirstName",
  },
  employeeId: {
    value: [],
  },
  title: {
    value: [],
    error: "",
    validation: { required: true },
    step: 1,
    positionCount: 1,
    // label: "STD-Employer-Statement.form.label.text.FirstName",
  },
  firstName: {
    value: "",
    error: "",
    validation: {
      required: true,
      matchPattern: ALPHANUMERICWITHSPACEREGEX,
      type: "name",
    },
    step: 1,
    positionCount: 1,
    // label: "STD-Employer-Statement.form.label.text.FirstName",
  },
  middleName: {
    value: "",
    error: "",
    validation: { matchPattern: ALPHANUMERICWITHSPACEREGEX, type: "name" },
    step: 1,
    positionCount: 1,
    // label: "STD-Employer-Statement.form.label.text.FirstName",
  },
  lastName: {
    value: "",
    error: "",
    validation: { matchPattern: ALPHANUMERICWITHSPACEREGEX, type: "name" },
    step: 1,
    positionCount: 1,
    // label: "STD-Employer-Statement.form.label.text.FirstName",
  },
  name: {
    value: "",
  },
  streetAddress1: {
    value: "",
  },
  address2: {
    value: "",
  },
  country: {
    value: [],
    step: 1,
    positionCount: 1,
    error: "",
    validation: { required: true },
    // label: "STD-Employer-Statement.form.label.text.FirstName",
  },
  province: {
    value: [],
    step: 1,
    positionCount: 1,
    error: "",
    validation: { required: true },
    // label: "STD-Employer-Statement.form.label.text.FirstName",
  },
  city: {
    value: [],
    step: 1,
    positionCount: 1,
    error: "",
    validation: { required: true },
    // label: "STD-Employer-Statement.form.label.text.FirstName",
  },
  postalCode: {
    value: "",
    error: "",
    validation: { required: true, minLength: 6, maxLength: 6 },
    step: 1,
    positionCount: 1,
    // label: "STD-Employer-Statement.form.label.text.FirstName",
  },
  birthDate: {
    value: "",
    error: "",
    validation: { isDate: true },
    step: 1,
  },
  gender: {
    value: "Male",
  },
  homeTelephoneNumber: {
    value: "",
    error: "",
    validation: {
      matchPattern: NUMBERREGEX,
      minLength: 10,
      maxLength: 10,
      type: "Telephone Number",
    },
    step: 1,
    positionCount: 1,
    // label: "STD-Employer-Statement.form.label.text.FirstName",
  },
  alternateNumber: {
    value: "",
    error: "",
    validation: {
      matchPattern: NUMBERREGEX,
      minLength: 10,
      maxLength: 10,
      type: "Telephone Number",
    },
    step: 1,
    positionCount: 1,
    // label: "STD-Employer-Statement.form.label.text.FirstName",
  },
  email: {
    value: "",
    error: "",
    validation: { required: true, matchPattern: EMAILREGEX, type: "Email" },
    step: 1,
    positionCount: 1,
    // label: "STD-Employer-Statement.form.label.text.FirstName",
  },
  employeeLanguagePreference: {
    value: "English",
  },
  externalId: {
    value: "",
    error: "",
    validation: { required: true, minLength: 9, maxLength: 9 },
    step: 2,
    positionCount: 1,
    // label: "STD-Employer-Statement.form.label.text.FirstName",
  },
  dateofHire: {
    value: "",
  },
  managerLanguagePreference: {
    value: "English",
  },
  division: {
    value: [],
    error: "",
    validation: { required: true },
    step: 2,
  },
  job: {
    value: [],
    error: "",
    validation: { required: true },
    step: 2,
  },

  ltdPlanLink: {
    value: [],
    error: "",
    validation: { required: true },
    step: 2,
  },
  fileContact: {
    value: [],
    error: "",
    validation: { required: true },
    step: 2,
  },
  fileContactPhone: {
    value: "",
    isActive: false,
    error: "",
    validation: {
      matchPattern: NUMBERREGEX,
      minLength: 10,
      maxLength: 10,
      type: "Phone Number",
    },
    step: 1,
    positionCount: 1,
    // label: "STD-Employer-Statement.form.label.text.FirstName",
  },
  fileContactEmail: {
    value: "",
    isActive: false,
    error: "",
    validation: { matchPattern: EMAILREGEX, type: "Email" },
    step: 1,
    positionCount: 1,
    // label: "STD-Employer-Statement.form.label.text.FirstName",
  },
  supervisor: {
    value: [],
    error: "",
    validation: { required: true },
    step: 2,
  },
  supervisorPhone: {
    value: "",
    isActive: false,
    error: "",
    validation: {
      matchPattern: NUMBERREGEX,
      minLength: 10,
      maxLength: 10,
      type: "Phone Number",
    },
    step: 1,
    positionCount: 1,
    // label: "STD-Employer-Statement.form.label.text.FirstName",
  },
  supervisorEmail: {
    value: "",
    isActive: false,
    error: "",
    validation: { matchPattern: EMAILREGEX, type: "Email" },
    step: 1,
    positionCount: 1,
    // label: "STD-Employer-Statement.form.label.text.FirstName",
  },
  hrc: {
    value: [],
    error: "",
    validation: { required: true },
    step: 2,
  },
  hrcPhone: {
    value: "",
    isActive: false,
    error: "",
    validation: {
      matchPattern: NUMBERREGEX,
      minLength: 10,
      maxLength: 10,
      type: "Phone Number",
    },
    step: 1,
    positionCount: 1,
    // label: "STD-Employer-Statement.form.label.text.FirstName",
  },
  hrcEmail: {
    value: "",
    isActive: false,
    error: "",
    validation: { matchPattern: EMAILREGEX, type: "Email" },
    step: 1,
    positionCount: 1,
    // label: "STD-Employer-Statement.form.label.text.FirstName",
  },
  ercName: {
    value: [],
    error: "",
    validation: { required: true },
    step: 2,
  },
  ercPhone: {
    value: "",
    isActive: false,
    error: "",
    validation: {
      matchPattern: NUMBERREGEX,
      minLength: 10,
      maxLength: 10,
      type: "Phone Number",
    },
    step: 1,
    positionCount: 1,
    // label: "STD-Employer-Statement.form.label.text.FirstName",
  },
  ercEmail: {
    value: "",
    isActive: false,
    error: "",
    validation: { matchPattern: EMAILREGEX, type: "Email" },
    step: 1,
    positionCount: 1,
    // label: "STD-Employer-Statement.form.label.text.FirstName",
  },
  additionalEmailRecipients: {
    value: "",
    error: "",
    validation: { matchPattern: EMAILREGEX, type: "Email Recipient" },
    step: 1,
    positionCount: 1,
    // label: "STD-Employer-Statement.form.label.text.FirstName",
  },
  socialInsuranceNumber: {
    value: "",
  },
  payMethod: {
    value: "Cheque",
  },
  bankingInformation: {
    value: "",
  },
  notes: {
    value: "",
  },
  searchBy: {
    value: "LastName",
  },
  searchText: {
    value: "",
  },
  searchEnable: { value: false },
  isSearch: { value: false },
  isSubmitOnce: { value: false },
};
